<template>
  <div class="container">
    <div class="header">
      <i class="icon-fanhui iconfont icon back"
         @click="back"
         style="position: absolute;left:0.1rem"></i>
      <div>开票申请</div>
    </div>
    <div class="content-ticket" >

      <div class="list-wrapper" v-if="ProList.length>0">
        <div v-for="(item,index) in  ProList"
             :key="index">
          <mt-cell-swipe :right="[
            {
              content: '提交',
              style:getcolor1(item.state),
               handler: function(){ addPro(item.id,item.state) }
            },
            {
              content: '编辑',
              style: {background: '#6DB0FB', color: '#fff',lineHeight:'2.8rem' },
               handler: function(){
                  editPro(item.id,item.state) }
            },
            {
              content: '删除',
              style:getcolor(item.state),
               handler: function(){ delPro(item.id,item.state) }
            }
                 ]">
            <!-- <div class="list-item">
            <p>创建时间{{item.created_at?(item.created_at.slice(0,10)):0}}</p>
            <div class="pro-name">
              <div class="left" @click="GotoOpenTicket(item.id,item.state)">
                <span class="ispass">{{Status[item.state]}}</span>
                <span style="display:inline-block;width:4rem;overflow: hidden;
                  text-overflow:ellipsis;white-space: nowrap;">{{item.project_name}}</span>
              </div>
              <div class="right">
                <span class="money">{{item.all_money}}</span><span class="unit">(元)</span>
                <span style="display:block;margin-top:4px;">开票金额（含税）</span>
              </div>
            </div>
            <div style="position: relative;top:-12px;">第{{item.period}}期</div>
          </div> -->
            <!--  -->
            <div class="list-item" style="padding-right:20px" @click="GotoOpenTicket(item.id,item.state)">
              <div class="row text">
                <span class="item-project"><span class="title">创建时间</span>{{item.created_at?(item.created_at.slice(0,10)):0}}</span>
                <span class="item-project">第{{item.period}}期</span>
              </div>
              <div class="row text">
                <span class="item-project">{{item.project_name}}</span>
                <span class="item-project"><span>{{Status[item.state]}}</span></span>
              </div>
              <div class="row">
                <div class="row-item">
                  <p class="item-value"><span class="symbol">¥</span> {{item.all_money}} <span class="unit">(元)</span></p>
                  <p class="item-name">开票金额（含税）</p>
                </div>
                <div class="row-item center">
                </div>
                <div class="row-item">
                  <p class="item-value"> <span class="symbol"></span> {{item.date}} <span class="unit">(天)</span> </p>
                  <p class="item-name">开票时长</p>
                </div>
              </div>
            </div>
            <!--  -->

          </mt-cell-swipe>

        </div>

      </div>
      <nodata v-if="ProList.length<=0"></nodata>
      <div class="store-wrap"
           style="background: #fff">
        <div class="storemsg"
             @click="openticketbtn">开票申请</div>
      </div>
    </div>

  </div>
</template>
<script>
   import nodata from '../public/nodata'
  import { Swipe, SwipeItem, MessageBox } from 'mint-ui';
  import Vue from 'vue'
  Vue.component(Swipe.name, Swipe);
  Vue.component(SwipeItem.name, SwipeItem);
  export default {
    components:{
      nodata
    },
    data () {
      return {
        ProList: [],//列表
        project_list: {},// 项目列表
        tax_list: {},//税率
        Status: {},//状态

      }
    },
    methods: {
      back () {//返回上一页
        this.$router.push({ name: 'my' })
      },
      getcolor (state) {
        if (state == 1) {
          return {
            background: '#E4BB51', color: '#fff', lineHeight: '2.8rem'
          }
        } else {
          return { background: '#ccc', color: '#fff', lineHeight: '2.8rem' }
        }
      },
      getcolor1 (state) {
        if (state == 5) {
          return {
            background: '#D185FF', color: '#fff', lineHeight: '2.8rem'
          }
        } else {
          return { background: '#ccc', color: '#fff', lineHeight: '2.8rem' }
        }
      },

      addPro (pid, state) {//添加按钮
        if (state == 5) {
          this.$http.getInvoicingCommit({ id: pid }).then(res => {
            if (res.errCode == 0) {
              MessageBox('提示', '提交成功!');
            }
            this.$http.getOpenTicketListdata().then(res => {
              this.ProList = res.data.data
              this.project_list = res.data.project_list
              // window.localStorage.setItem( 'prolist', JSON.stringify(this.project_list) )
              this.tax_list = res.data.tax_list
              console.log(res.data.tax_list)
              // console .log(res.data.log_data,'log_data')
              this.Status = res.data.status//状态
            })

          })
        }
        else {
          MessageBox('提示', '您当前状态下不能提交!');
        }


      },
      editPro (PID, state) {//编辑按钮跳转到开票页申请页面
        this.$router.push({ name: 'openticket', params: { id: PID, state: state } })
        let step = {
          step: 2,
        }
        window.localStorage.setItem('step', JSON.stringify(step))
      },
      delPro (TicketId, TicketState) {//删除项目提示框
        if (TicketState == 5 || TicketState == 1 || TicketState == 4) {
          MessageBox.confirm('', {
            message: '你确定要删除此项目？',
            title: '提示',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(action => {
            if (action == 'confirm') {     //确认的回调
              this.$http.getInvoicingRemove({ id: TicketId }).then(res => {
                if (res.errCode == 0) {
                  this.$http.getOpenTicketListdata().then(res => {
                    this.ProList = res.data.data
                    this.Status = res.data.status//状态
                  })
                  MessageBox('提示', '删除成功');
                } else {
                  MessageBox('提示', res.errMsg);
                }
              })
              console.log('确定');
            }
          }).catch(err => {
            if (err == 'cancel') {     //取消的回调
              console.log('取消');
            }
          });
        } else {//
          MessageBox('提示', '开票信息已提交，无法删除!');
        }

      },
      GotoOpenTicket (TicketId, state) {//点击项目名称去到项目开票页面2
        this.$router.push({ name: 'openticket', params: { id: TicketId, step: 2, state: state, Status: this.Status, project_list: this.project_list, tax_list: this.tax_list } })
        let data = {
          id: TicketId,
          state: state,
          Status: this.Status,
          project_list: this.project_list,
          tax_list: this.tax_list
        }
        window.localStorage.setItem('opeticket', JSON.stringify(data))
        console.log(data)
        let step = {
          step: 2,
        }
        window.localStorage.setItem('step', JSON.stringify(step))


      },
      openticketbtn () {//点击开票申请按钮1
        this.$router.push({ name: 'openticket', params: { step: 1, project_list: this.project_list, tax_list: this.tax_list, state: 5 } })
        let data = {
          // step:1,
          project_list: this.project_list,
          tax_list: this.tax_list
        }
        window.localStorage.setItem('opeticket2', JSON.stringify(data))
        let step = {
          step: 1,
        }
        window.localStorage.setItem('step', JSON.stringify(step))

      },
    },
    created () {
      this.$http.getOpenTicketListdata().then(res => {
        this.ProList = res.data.data
        this.project_list = res.data.project_list
        // window.localStorage.setItem( 'prolist', JSON.stringify(this.project_list) )
        this.tax_list = res.data.tax_list
        this.Status = res.data.status//状态
      })
    }
  }
</script>
<style scoped>
  .list-item {
    /*margin: 0.15625rem;*/
    /*background-color: #fff;*/
    border-radius: 0.0625rem;
    border-left: 0.09375rem solid #5482d2;
    margin-left: -2px;
    width: 10rem;
    padding: 0.2rem 0.1rem 0.2rem 0.1rem;
    /* box-shadow: 0 0 0 #ccc; */
  }
.list-item>div{
  padding:2px;
}
.item-project{
  font-size:14px;
}
.item-name{
  margin-top:5px;
  font-size: 12px;
}
  .container {
    width: 100%;
    background-color: #fff;
    overflow-x: hidden;
  }
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: relative;
    z-index: 99;
    border-bottom: 1px solid #ccc;
  }
  .list-wrapper {
    /*height:650px;*/
    overflow: scroll;
    padding-bottom: 3.8rem;
  }

  .pro-name {
    overflow: hidden;
    padding-top: 10px;
    font-size: 13px;
    /*position: relative;*/
    /*top:-6px;*/
    height: 45px;
  }
  .left {
    float: left;
    width: 77%;
  }
  .right {
    position: relative;
    top: -0.6rem;
    float: right;
    width: 33%;
    margin-right: 0rem;
  }
  .ispass {
    border: 1px solid #5483d2;
    border-radius: 3px;
    color: #5483d2;
    padding: 0 1px;
    margin-left: 4px;
  }
  .money {
    color: #5482d2;
    font-size: 16px;
  }
  .unit {
    color: #5482d2;
  }

  .list-wrapper /deep/ .mint-cell-title {
    flex: 0;
  }
  .store-wrap {
    width: 100%;
    background: #fff;
    height: 3rem;
    /*padding:0.8rem;*/
    /*margin-left:0.8rem;*/
    position: fixed;
    z-index: 10;
    bottom: 0;
  }
  .storemsg {
    border: 1.2px solid #5483d2;
    width: 8rem;
    text-align: center;
    height: 1rem;
    line-height: 1rem;
    border-radius: 0.5rem;
    font-size: 14px;
    color: #5483d2;
    margin: 1rem;
  }
   .list-wrapper /deep/ a{
        text-decoration:none;
    }
    .list-wrapper /deep/ .mint-cell-wrapper{
       background:#fff;

    }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/OpenTicketList.vue